import { Component, Vue } from 'nuxt-property-decorator'
import { getPromoTheme } from '~/core/config/promo-theme'

@Component
export default class PromoThemeMixin extends Vue {
  get promoThemeOptions () {
    return getPromoTheme(this.$nuxt)
  }
}
